import { faHourglass } from '@fortawesome/pro-solid-svg-icons';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';
import ProjectAppBar from '../ProjectPage/ProjectAppBar/ProjectAppBar';
import CombinationPlanDialog from './Components/Dialogs/CombinationPlanDialog';
import TagBasedPlanDialog from './Components/Dialogs/TagBasedPlanDialog';
import NewContentPlanButton from './NewContentPlanButton';
import NewContentPlanDialog from './NewContentPlanDialog';

export interface NewPlanPageProps {
  project: ProjectGq;
  user: CurrentUserGq;
  reload: () => Promise<unknown>;
  unfinishedScrape?: number;
  allDataRetrieved?: boolean;
  setProcessingOpen?: Dispatch<SetStateAction<boolean>>;
  newContentPlanOpen: boolean;
  setNewContentPlanOpen: Dispatch<SetStateAction<boolean>>;
}

const NewPlanPage: React.FC<NewPlanPageProps> = ({
  allDataRetrieved,
  setProcessingOpen,
  project,
  reload,
  user,
  unfinishedScrape,
  newContentPlanOpen,
  setNewContentPlanOpen,
}) => {
  const [useTagsOpen, setUseTagsOpen] = useState(false);
  const [useCombiOpen, setUseCombiOpen] = useState(false);

  return (
    <div className={`${!!unfinishedScrape ? 'relative' : ''}`}>
      <ProjectAppBar project={project} user={user} />
      <VoxelPageContainer className={`${!!unfinishedScrape ? 'opacity-50 ' : ''}`}>
        <div className="mt-24 mx-auto w-[600px] flex flex-col  gap-12">
          <div>
            <VoxelText variant="title2" paddingBot >
              Create content plan
            </VoxelText>
            <VoxelText variant="bread-medium" >
              Map keywords to relevant pages, suggesting optimization or new content for SEO growth.
            </VoxelText>
          </div>
          <NewContentPlanButton
            setNewContentPlanOpen={setNewContentPlanOpen}
            hasExistingPlan={false}
            disabled={!!unfinishedScrape}
          />
        </div>
        {!!unfinishedScrape && (
          <div className="absolute w-96 top-1/2 mx-auto inset-0 z-10">
            <VoxelAlert
              size="sm"
              severity="info"
              iconSize="xl"
              fontAIconName={faHourglass}
              title={'Scraping urls in progress: ' + unfinishedScrape}
            ></VoxelAlert>
          </div>
        )}
      </VoxelPageContainer>
      {allDataRetrieved && (
        <TagBasedPlanDialog
          openDialog={useTagsOpen}
          setOpenDialog={setUseTagsOpen}
          project={project}
          setProcessingOpen={setProcessingOpen}
          reload={reload}
        />
      )}
      {allDataRetrieved && (
        <CombinationPlanDialog
          openDialog={useCombiOpen}
          setOpenDialog={setUseCombiOpen}
          project={project}
          setProcessingOpen={setProcessingOpen}
          reload={reload}
        />
      )}
      <NewContentPlanDialog
        project={project}
        unfinishedScrape={unfinishedScrape}
        setUseTagsOpen={setUseTagsOpen}
        setCombiOpen={setUseCombiOpen}
        setProcessingOpen={setProcessingOpen}
        reload={reload}
        hasExistingPlan={false}
        newContentPlanOpen={newContentPlanOpen}
        setNewContentPlanOpen={setNewContentPlanOpen}
      />
    </div>
  );
};

export default NewPlanPage;
